import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarClock = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9 4c.55 0 1 .45 1 1v3h12V5c0-.55.45-1 1-1s1 .45 1 1v3h2c2.206 0 4 1.794 4 4v4.044A10.626 10.626 0 0 0 29 16c-.337 0-.669.012-1 .044V16H4v16c0 1.106.894 2 2 2h14.512a11.14 11.14 0 0 0 2.163 2H6c-2.206 0-4-1.794-4-4V12c0-2.206 1.794-4 4-4h2V5c0-.55.45-1 1-1Zm17 6H6c-1.106 0-2 .894-2 2v2h24v-2c0-1.106-.894-2-2-2Zm3 24a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-16a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm0 4c.55 0 1 .45 1 1v3h2c.55 0 1 .45 1 1s-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1Z" })
});
export default SvgCalendarClock;
